import * as React from "react"

import { cn } from "@/lib/utils"

export function Breadcrumb({ className, ...props }: React.HTMLAttributes<HTMLElement>) {
    return <nav aria-label='breadcrumb' className={cn("w-full", className)} {...props} />
}

export function BreadcrumbList({ className, ...props }: React.HTMLAttributes<HTMLOListElement>) {
    return <ol className={cn("flex flex-wrap items-center gap-1 text-sm text-muted-foreground", className)} {...props} />
}

export function BreadcrumbItem({ className, ...props }: React.LiHTMLAttributes<HTMLLIElement>) {
    return <li className={cn("inline-flex items-center gap-1", className)} {...props} />
}

export function BreadcrumbLink({ className, ...props }: React.AnchorHTMLAttributes<HTMLAnchorElement>) {
    return <a className={cn("hover:text-foreground transition-colors", className)} {...props} />
}

export function BreadcrumbSeparator({ className, children = "/", ...props }: React.HTMLAttributes<HTMLSpanElement>) {
    return (
        <span role='presentation' aria-hidden='true' className={cn("px-1", className)} {...props}>
            {children}
        </span>
    )
}

export function BreadcrumbPage({ className, ...props }: React.HTMLAttributes<HTMLSpanElement>) {
    return <span aria-current='page' className={cn("font-medium text-foreground", className)} {...props} />
}


